import { useGetEdpTransformedImageQuery } from "@/services/mediaService";
import { useEffect } from "react";

const useTransformedImageUrl = (imageUrl?: string) => {
  // Only fetch transformed image if URL contains s3.amazonaws.com
  const shouldTransform =
    imageUrl?.includes("https://s3.amazonaws.com") || false;

  const {
    data: blob,
    isError,
    isFetching,
    error,
  } = useGetEdpTransformedImageQuery(
    { imageUrl: imageUrl || "" },
    {
      skip: !imageUrl || !shouldTransform,
    },
  );

  // Create blob URL directly from the blob data
  const blobUrl = blob ? URL.createObjectURL(blob) : null;

  // Cleanup blob URL when component unmounts or blob changes
  useEffect(() => {
    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [blobUrl]);

  // Return blob URL if transformation was performed and successful, otherwise return original URL
  const transformedImageUrl = shouldTransform ? blobUrl || imageUrl : imageUrl;

  return {
    transformedImageUrl,
    isLoading: shouldTransform ? isFetching : false,
    isError: shouldTransform ? isError : false,
    error: shouldTransform ? error : null,
  };
};

export default useTransformedImageUrl;
